module.exports = __webpack_public_path__ + "img/defaultLogo.74eb6a1c.png";